# These are useful in a keydown or keyup event
module.exports = KeyLocations =
  8: 'Backspace'
  9: 'Tab'
  10: 'LineFeed'
  13: 'Enter'
  27: 'Escape'
  46: 'Delete'

  16: 'Shift'
  17: 'Control'
  18: 'Alt'
  20: 'CapsLock'

  33: 'PageUp'
  34: 'PageDown'
  35: 'End'
  36: 'Home'
  37: 'ArrowLeft'
  38: 'ArrowUp'
  39: 'ArrowRight'
  40: 'ArrowDown'



// WEBPACK FOOTER //
// ./app/scripts/data/key-locations.coffee